import type { IconSvgObject } from './types';

const CircleArrowOutUpLeftIcon: IconSvgObject = [
  ["path", { d: "M4.22302 11C4.07706 11.6432 4 12.3126 4 13C4 17.9706 8.02944 22 13 22C17.9706 22 22 17.9706 22 13C22 8.02944 17.9706 4 13 4C12.3126 4 11.6432 4.07706 11 4.22302", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 12L2 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 8V2H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CircleArrowOutUpLeftIcon;
